import { Injectable } from '@angular/core';
import { MontagePriceService } from 'app/services/montage-price.service';
import { CenaMontazu } from 'app/model/cena';
import { RecommendationService } from 'app/services/recommendation.service';
import { OfferService } from 'app/services/offer.service';
import { Oferent } from 'app/model/oferent';
import { WojewodztwaService, EnumWojewodztwo } from 'app/services/wojewodztwa.service';

@Injectable()
export class InstallationcostService {

  instCost: number;
  offer: Oferent;

  constructor(
    private offerService: OfferService,
    private montagePriceService: MontagePriceService,
    private recommendationService: RecommendationService,
    private wojewodztwaService: WojewodztwaService) { }

  updateCosts() {
    const priceData = this.getInstalationCost4Power();
    if (!priceData) {
      return;
    }
    this.instCost = priceData.cena;
    this.recommendationService.setInstallationCost(this.instCost);
    this.offerService.getOffer(priceData.dostawca_id).subscribe(offer => {
      this.offer = offer;
    });
  }

  getInstalationCost4Oferent(oferentId: string): CenaMontazu {
    const powerKW = this.recommendationService.getMatchingPanelsPower();
    if (!powerKW) {
      return new CenaMontazu();
    }
    let bestPrice: CenaMontazu = new CenaMontazu();
    for (const c of this.montagePriceService.PRICES) {
      if (c.dostawca_id === oferentId) {
        if (powerKW >= c.moc_od && powerKW < c.moc_do) {
          if (bestPrice.cena === 0 || bestPrice.cena > c.cena) {
            bestPrice = c;
          }
        }
      }
    }
    return bestPrice;
  }

  getInstalationCost4Power(): CenaMontazu {
    const powerKW = this.recommendationService.getMatchingPanelsPower();
    if (!powerKW) {
      return new CenaMontazu();
    }
    let bestPrice: CenaMontazu;
    for (const c of this.montagePriceService.PRICES) {
      // check dachLocation
      if (c.confirmed) {
        const ofr = this.offerService.getOfr(c.dostawca_id);
        let bOk = ofr.wojewodztwa[0] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.lub);
        bOk = bOk || (ofr.wojewodztwa[1] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.maz));
        bOk =  bOk || (ofr.wojewodztwa[2] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.podk));
        bOk =  bOk || (ofr.wojewodztwa[3] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.swiet));

        if (bOk) {
          if (powerKW >= c.moc_od && powerKW < c.moc_do && (!bestPrice || bestPrice.cena > c.cena)) {
            bestPrice = c;
          }
        }
      }
    }
    return bestPrice;
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/installationcost.service.ts